import { Grid, GridItem } from "@chakra-ui/react";
import "@/components/common/section-components/card/text-elements.css";
import { LinearProgress } from "@/components/progress";
import { PricesData } from "../schema/price-board.schema";
import { MarketPricesCard } from "./prices/MarketPricesCard";
import { UnionPricesCard } from "./prices/UnionPricesCard";
import { NoData } from "@/components/common/section-components/NoData";

interface Props {
  loadingPrices: boolean;
  sectionData?: PricesData;
}

export const PricesTable = ({ loadingPrices, sectionData }: Props) => {
  return loadingPrices ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingPrices &&
      Boolean(!sectionData?.preciosMercado?.length) &&
      Boolean(!sectionData?.preciosUnion.length) ? (
        <NoData />
      ) : (
        <Grid
          templateColumns={`repeat(2, 1fr)`}
          gap="24px"
          paddingX="12px"
          data-testid="prices-table"
        >
          {Boolean(sectionData?.preciosMercado?.length) && (
            <GridItem>
              <MarketPricesCard sectionData={sectionData} />
            </GridItem>
          )}
          {Boolean(sectionData?.preciosUnion?.length) && (
            <GridItem>
              <UnionPricesCard sectionData={sectionData} />
            </GridItem>
          )}
        </Grid>
      )}
    </>
  );
};
